export default {
  sm: `
  데이터센터 각 로고
  `
};
